import { DarePlatform, Platform } from 'root/src/shared/@types/platforms';
export function isPlatform(value) {
    return typeof value === 'string' && Object.values(Platform).includes(value);
}
export function isDarePlatform(value) {
    return typeof value === 'string' && Object.values(DarePlatform).includes(value);
}
